/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

/**
 * All of the possible `BillerInvoiceStatus*`'s.
 */
export type BillerInvoiceStatusCode =
  | BillerInvoiceStatusDraft
  | BillerInvoiceStatusPending
  | BillerInvoiceStatusOpen
  | BillerInvoiceStatusProcessing
  | BillerInvoiceStatusPaid
  | BillerInvoiceStatusVoided
  | BillerInvoiceStatusCancelled;

/**
 * Status draft.
 * @export
 */
export type BillerInvoiceStatusDraft = typeof BILLER_INVOICE_STATUS_DRAFT;

/**
 * Status pending.
 * @export
 */
export type BillerInvoiceStatusPending = typeof BILLER_INVOICE_STATUS_PENDING;

/**
 * Status open.
 * @export
 */
export type BillerInvoiceStatusOpen = typeof BILLER_INVOICE_STATUS_OPEN;

/**
 * Status processing.
 * @export
 */
export type BillerInvoiceStatusProcessing = typeof BILLER_INVOICE_STATUS_PROCESSING;

/**
 * Status paid.
 * @export
 */
export type BillerInvoiceStatusPaid = typeof BILLER_INVOICE_STATUS_PAID;

/**
 * Status voided.
 * @export
 */
export type BillerInvoiceStatusVoided = typeof BILLER_INVOICE_STATUS_VOIDED;

/**
 * Status cancelled.
 * @export
 */
export type BillerInvoiceStatusCancelled = typeof BILLER_INVOICE_STATUS_CANCELLED;

/**
 * Status draft constant.
 * @export
 */
export const BILLER_INVOICE_STATUS_DRAFT = `draft`;

/**
 * Status pending constant.
 * @export
 */
export const BILLER_INVOICE_STATUS_PENDING = `pending`;

/**
 * Status open constant.
 * @export
 */
export const BILLER_INVOICE_STATUS_OPEN = `open`;

/**
 * Status processing constant.
 * @export
 */
export const BILLER_INVOICE_STATUS_PROCESSING = `processing`;

/**
 * Status paid constant.
 * @export
 */
export const BILLER_INVOICE_STATUS_PAID = `paid`;

/**
 * Status voided constant.
 * @export
 */
export const BILLER_INVOICE_STATUS_VOIDED = `voided`;

/**
 * Status cancelled constant.
 * @export
 */
export const BILLER_INVOICE_STATUS_CANCELLED = `canceled`;
